// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: producer/producer.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Value } from "../google/protobuf/struct";
import { ProducerKind, producerKindFromJSON, producerKindToJSON } from "./producer_kind";
import { ProducerLabel, producerLabelFromJSON, producerLabelToJSON } from "./producer_label";

export const protobufPackage = "producer";

export interface Producer {
  id: string;
  kind: ProducerKind;
  label: ProducerLabel;
  peerId: string;
  paused: boolean;
  encodings: any[];
  maxSpatialLayer?: number | undefined;
}

function createBaseProducer(): Producer {
  return { id: "", kind: 0, label: 0, peerId: "", paused: false, encodings: [], maxSpatialLayer: undefined };
}

export const Producer: MessageFns<Producer> = {
  encode(message: Producer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.label !== 0) {
      writer.uint32(24).int32(message.label);
    }
    if (message.peerId !== "") {
      writer.uint32(34).string(message.peerId);
    }
    if (message.paused !== false) {
      writer.uint32(40).bool(message.paused);
    }
    for (const v of message.encodings) {
      Value.encode(Value.wrap(v!), writer.uint32(50).fork()).join();
    }
    if (message.maxSpatialLayer !== undefined) {
      writer.uint32(56).uint32(message.maxSpatialLayer);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Producer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProducer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.label = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.peerId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.paused = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.encodings.push(Value.unwrap(Value.decode(reader, reader.uint32())));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.maxSpatialLayer = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Producer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      kind: isSet(object.kind) ? producerKindFromJSON(object.kind) : 0,
      label: isSet(object.label) ? producerLabelFromJSON(object.label) : 0,
      peerId: isSet(object.peerId) ? globalThis.String(object.peerId) : "",
      paused: isSet(object.paused) ? globalThis.Boolean(object.paused) : false,
      encodings: globalThis.Array.isArray(object?.encodings) ? [...object.encodings] : [],
      maxSpatialLayer: isSet(object.maxSpatialLayer) ? globalThis.Number(object.maxSpatialLayer) : undefined,
    };
  },

  toJSON(message: Producer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.kind !== 0) {
      obj.kind = producerKindToJSON(message.kind);
    }
    if (message.label !== 0) {
      obj.label = producerLabelToJSON(message.label);
    }
    if (message.peerId !== "") {
      obj.peerId = message.peerId;
    }
    if (message.paused !== false) {
      obj.paused = message.paused;
    }
    if (message.encodings?.length) {
      obj.encodings = message.encodings;
    }
    if (message.maxSpatialLayer !== undefined) {
      obj.maxSpatialLayer = Math.round(message.maxSpatialLayer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Producer>, I>>(base?: I): Producer {
    return Producer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Producer>, I>>(object: I): Producer {
    const message = createBaseProducer();
    message.id = object.id ?? "";
    message.kind = object.kind ?? 0;
    message.label = object.label ?? 0;
    message.peerId = object.peerId ?? "";
    message.paused = object.paused ?? false;
    message.encodings = object.encodings?.map((e) => e) || [];
    message.maxSpatialLayer = object.maxSpatialLayer ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
